import React, { useState } from "react"
import Header from "../../components/navigation/Header"
import Footer from "../../components/navigation/Footer"
import CreateCSFR from "../../hooks/userAuthentication/CreateCSFR"
import axios from "axios"
import ReCAPTCHA from "react-google-recaptcha"

export default function ForgotPassword(){
    const [captchaToken, setCaptchaToken] = useState<string | null>(null)
    const [invalidCaptcha, setInvalidCaptcha] = useState(true)
    const csrfToken = CreateCSFR({ name: "csrftoken" })
    const [accountEmail, setAccountEmail] = useState<string>()
    const [submitted, setSubmitted] = useState<boolean>(false)

    const handleCaptchaChange = (value: string | null) => {
        if (value) {
            setCaptchaToken(value)
            setInvalidCaptcha(false)

            axios.post(`${process.env.REACT_APP_SKILLJA_URL}/verify_captcha/`, { token: value }, {
                headers: { 'X-CSRFToken': csrfToken, 'Content-Type': 'application/json' },
                withCredentials: true,
            })
            .then(res => setInvalidCaptcha(!res.data.success))
            .catch(() => setInvalidCaptcha(true))
        } 
        else {
            setInvalidCaptcha(true)
        }
    }

    function submitPasswordReset(){
        if (!accountEmail || !accountEmail.includes("@")) return

        axios.post(`${process.env.REACT_APP_SKILLJA_URL}/forgot_password/`, { recipient: accountEmail }, {
            headers: { 'X-CSRFToken': csrfToken, 'Content-Type': 'application/json' },
            withCredentials: true,
        })
        .then((res) => {
            if(res.status === 200)
            setSubmitted(true)}
        )
        .catch(() => setSubmitted(false))
    }

    return (
        <div>
            <Header />
            <div className="text-center mx-auto mt-20 mb-52 font-kulim">
                <p className="max-w-2xl px-5 mx-auto text-center mb-16">
                    Please enter the email you use to sign into SkillJa. We'll send you an email allowing you to reset your password.
                </p>
                {!submitted ?
                    <form 
                        className="m-auto w-80"
                        onSubmit={(e) => {
                            e.preventDefault()
                            submitPasswordReset()
                        }}
                    >
                        <input 
                            type="text" 
                            placeholder="Enter your email"
                            className="form-input px-3"
                            onChange={(e)=>setAccountEmail(e.target.value)}
                        />
                        {invalidCaptcha ?
                            <div className="mt-5 mb-3 recaptcha-container">
                                {invalidCaptcha && process.env.REACT_APP_RECAPTCHA_PUBLIC_KEY && (
                                    <ReCAPTCHA
                                        onChange={handleCaptchaChange}
                                        sitekey={process.env.REACT_APP_RECAPTCHA_PUBLIC_KEY!}
                                        onExpired={() => setCaptchaToken(null)}
                                    />
                                )}
                            </div>
                        :
                            <button
                                className={`form-btn px-4 py-1.5 mt-8 ${invalidCaptcha && 'cursor-not-allowed'}`}
                                disabled={invalidCaptcha}
                            >
                                Reset Password
                            </button>
                        }
                    </form>
                :
                    <p className="text-center text-main-green-600 mx-auto my-3 px-6 font-semibold">
                        Your password reset request has been submitted!
                    </p>
                }
            </div>
            <Footer />
        </div>
    )
}